import GuiContext from "config/context/guiContext";
import { useContext, useState } from "react";
import { useCompositionsContext } from "../context/CompositionsContext";

export const useGetDatabaseStructureService= () => {
    const { setDatabaseStructure, startLoading, stopLoading } = useCompositionsContext();
    const [response, setResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const {
        selected: { selectedAccount, selectedServer },
        URL
    } = useContext(GuiContext);

    const getDatabaseStructure = async () => {
        setLoading(true);
        startLoading('getDatabaseStructure');
        try {
            const res = await fetch(`${URL}/api/database/structure`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    database: selectedAccount || "",
                    server_url: selectedServer || "",
                }),
            });

            const data = await res.json();
            setResponse(data);
            setDatabaseStructure({
                database: data?.database,
                compositions: data?.compositions
            });
            if (!data?.status) {
                setError(data?.message);
            }
        } catch (err) {
            setError(err.message || 'An error occurred');
        } finally {
            setLoading(false);
            stopLoading('getDatabaseStructure');
        }
    }

    return {
        response,
        loading,
        error,
        getDatabaseStructure
    }
}